var scope_0 = require('/home/esde/git/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7d5063245cec3baa4a677fcbd233fc65.js').default;
var scope_1 = require('/home/esde/git/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d89cb302d0557210efc54e84171165f4.js').default;
var scope_2 = require('/home/esde/git/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    